import * as _ from "lodash-es";
import { CHARS_IN_SMS } from "./constants";

export const countSMSTextSegments = (text) => Math.ceil(text.length / CHARS_IN_SMS);

/**
 * @param {Array} messages Incoming/Outgoing sms messages
 * @returns {int} Number of segments of outgoing messages
 */
export const countOutgoingSMSSegments = (messages) =>
  _.sum(
    messages
      .filter((message) => message.is_outgoing)
      .map((message) => countSMSTextSegments(message.message)),
  );
